import { useState, useEffect, useCallback, useRef } from 'react';
import { Breakpoints } from '@ciceksepeti/cs-theme';
import { isMobile } from '@ciceksepeti/cs-user-agent';
export var useResponsive = function () {
    var isMobileDevice = isMobile(navigator.userAgent);
    var initialWidth = typeof window !== 'undefined' ? window.innerWidth : 0;
    var _a = useState(initialWidth), windowWidth = _a[0], setWindowWidth = _a[1];
    var lastWidthRef = useRef(initialWidth);
    var isTabletDesktop = !isMobileDevice && windowWidth <= Breakpoints.SCREEN_SM;
    var isTabletMobile = isMobileDevice && windowWidth >= Breakpoints.SCREEN_SM;
    var handleResize = useCallback(function () {
        var currentWidth = window.innerWidth;
        var lastWidth = lastWidthRef.current;
        var wasSmallScreen = lastWidth < Breakpoints.SCREEN_SM;
        var isNowSmallScreen = currentWidth < Breakpoints.SCREEN_SM;
        var crossedBreakpoint = wasSmallScreen !== isNowSmallScreen;
        if (crossedBreakpoint) {
            lastWidthRef.current = currentWidth;
            setWindowWidth(currentWidth);
        }
    }, []);
    useEffect(function () {
        if (!isMobileDevice)
            return;
        lastWidthRef.current = window.innerWidth;
        var requestAnimationFrameId = requestAnimationFrame(function () {
            handleResize();
        });
        window.addEventListener('resize', handleResize);
        return function () {
            cancelAnimationFrame(requestAnimationFrameId);
            window.removeEventListener('resize', handleResize);
        };
    }, [handleResize, isMobileDevice]);
    return {
        isMobileDevice: isMobileDevice,
        isTabletDesktop: isTabletDesktop,
        isTabletMobile: isTabletMobile
    };
};
